import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { transactionsService } from '../services/transactionService'
import { useEffect, useState } from 'react'
import { useAuth } from './useAuth'
import { endOfMonth, endOfToday, startOfMonth, startOfToday } from 'date-fns'
import { useLocation } from 'react-router-dom'
import { WithdrawService } from '../services/WithdrawService'
import { PartnerType } from '../utils/partners.enum'
interface useStatisticsProps {
  interval?: number | false
}

type paramsType = {
  startDate: string
  endDate: string
  sellerIds?: string
  teamIds?: string
  status?: string
  leaderIds?: string
  managerIds?: string
  type?: string
}
export const useStatistics = ({ interval = false }: useStatisticsProps) => {
  const { user, isAdmin, signedIn, isLoading: loadingUser } = useAuth()
  const { pathname } = useLocation()

  const inReport = pathname === '/relatorios'
  const initMonth = startOfMonth(new Date()).toISOString()
  const endMonth = endOfMonth(new Date()).toISOString()

  const [params, setParams] = useState<paramsType>({
    startDate: inReport ? initMonth : startOfToday().toISOString(),
    endDate: inReport ? endMonth : endOfToday().toISOString(),
    type: inReport ? undefined : PartnerType.FGTS,
  })

  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['statistics', user?._id, params],
    queryFn: async () =>
      transactionsService.transaction({ ...params, flag: 'statistics' }),
    select(data) {
      return {
        statistics: data.statitics,
        teamStatisticas: data.teamStatistics,
      }
    },
    refetchInterval: interval,
    placeholderData: keepPreviousData,
  })

  const { data: availableAmount, ...availableQuery } = useQuery({
    queryKey: ['available amount', isAdmin, user?._id, params],
    enabled: isAdmin && !!user?._id && signedIn && loadingUser === false,
    queryFn: () => WithdrawService.getAmount(),
    refetchInterval: interval,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
    availableAmount: availableAmount?.amount || 0,
    adminAmount: availableAmount?.adminAmount || 0,
    availableisLoading: availableQuery.isLoading || availableQuery.isFetching,
  }
}
